import { useMemo, type ReactNode } from 'react';

import { CanvasActionCardPlacementContext } from './canvas-action-card-placement-context';
import { useCanvasOnlyActionCardIds } from './useCanvasActionCardPlacements';

export const CanvasActionCardPlacementProvider = ({
  fileIds,
  children,
}: {
  fileIds: string[];
  children: ReactNode;
}) => {
  const { canvasOnlyLocalIds, isLoading } = useCanvasOnlyActionCardIds(fileIds);
  const placements = useMemo(
    () => ({ canvasOnlyLocalIds, isLoading }),
    [canvasOnlyLocalIds, isLoading]
  );

  return (
    <CanvasActionCardPlacementContext.Provider value={placements}>
      {children}
    </CanvasActionCardPlacementContext.Provider>
  );
};
